/**
 * Author(s) : Alagu Bala Ganapathy A
 * Purpose : This Component is used to get the count down timer.
 */
import { useCountDownTimer } from '../../hooks/useCountDownTimer';
import PropTypes from 'prop-types';
import styles from './Timer.module.scss';
import {
  HEADER_CONSTANTS,
  TIMER_STATE,
} from '../../constants/header-constants';

const Timer = ({ countTo, eventStartDate, eventEndDate }) => {
  const timerState = useCountDownTimer(countTo, eventStartDate, eventEndDate);
  let days, hours, minutes, seconds;
  if (
    timerState[0] !== TIMER_STATE.afterEvent ||
    timerState[0] !== TIMER_STATE.live
  ) {
    [days, hours, minutes, seconds] = timerState;
  }
  return (
    <>
      {timerState[0] !== TIMER_STATE.live &&
      timerState[0] !== TIMER_STATE.afterEvent ? (
        <>
          <span>{HEADER_CONSTANTS.beforeEvent}</span>
          <div className={styles.timers}>
            <div className={styles.numbers}>{days}</div>
            <span className={styles.constants}>{HEADER_CONSTANTS.days}</span>
            <div className={styles.colons}>:</div>
            <div className={styles.numbers}>{hours}</div>
            <span className={styles.constants}>{HEADER_CONSTANTS.hours}</span>
            <div className={styles.colons}>:</div>
            <div className={styles.numbers}>{minutes}</div>
            <span className={styles.constants}>{HEADER_CONSTANTS.minutes}</span>
            <div className={styles.colons}>:</div>
            <div className={styles.numbers}>{seconds}</div>
            <span className={styles.constants}>{HEADER_CONSTANTS.seconds}</span>
          </div>
        </>
      ) : (
        <div className={styles.timers}>{HEADER_CONSTANTS[timerState[0]]}</div>
      )}
    </>
  );
};

Timer.defaultProps = {
  countTo: 'Oct 19, 2022 16:00:00',
  eventStartDate: new Date(2022, 9, 19, 16),
  eventEndDate: new Date(2022, 9, 21),
};

Timer.propTypes = {
  countTo: PropTypes.string,
  eventStartDate: PropTypes.instanceOf(Date),
  eventEndDate: PropTypes.instanceOf(Date),
};

export default Timer;
